import React from 'react';
import { Header } from '../components/Header';
import { Hero } from '../components/Hero';
import { ProblemSolutionSection } from '../components/ProblemSolutionSection';
import { ProductReveal } from '../components/ProductReveal';
import { ModulesGrid } from '../components/ModulesGrid';
import { BonusStack } from '../components/BonusStack';
import { ValueComparison } from '../components/ValueComparison';
import { Testimonials } from '../components/Testimonials';
import { FinalCTA } from '../components/FinalCTA';
import { Footer } from '../components/Footer';
import { SocialProofPopup } from '../components/SocialProofPopup';
export function LandingPage() {
  return <div className="w-full min-h-screen bg-[#0B1C2C]" data-id="element-313">
      <Header data-id="element-314" />
      <Hero data-id="element-315" />
      <ProblemSolutionSection data-id="element-316" />
      <ProductReveal data-id="element-317" />
      <ModulesGrid data-id="element-318" />
      <BonusStack data-id="element-319" />
      <ValueComparison data-id="element-320" />
      <FinalCTA data-id="element-321" />
      <Testimonials data-id="element-322" />
      <Footer data-id="element-323" />
      <SocialProofPopup data-id="element-324" />
    </div>;
}